import { Link } from "react-router-dom";

const entries = [
  {
    type: "movie",
    to: "/category/movie",
    title: "电影频道",
    desc: "动作、科幻、悬疑、爱情……海量院线大片与经典佳作一网打尽。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20movie%20theater%20with%20dark%20blue%20seats%20and%20warm%20orange%20spotlight%2C%20film%20reels%20and%20screen%20glow%2C%20moody%20artistic%20portal%20banner&width=1200&height=675&seq=tl-cat-movie&orientation=landscape",
  },
  {
    type: "tv",
    to: "/category/tv",
    title: "电视剧频道",
    desc: "都市情感、古装权谋、刑侦悬疑，追剧不停，总有一部适合你。",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20living%20room%20at%20night%20with%20glowing%20tv%20screen%2C%20deep%20blue%20ambient%20light%20with%20warm%20orange%20glow%2C%20cinematic%20artistic%20portal%20banner&width=1200&height=675&seq=tl-cat-tv&orientation=landscape",
  },
];

export default function CategoryEntry() {
  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 md:px-8 py-10 md:py-14">
      <div className="grid grid-cols-1 gap-4 md:gap-5 sm:grid-cols-2">
        {entries.map((entry) => (
          <Link
            key={entry.type}
            to={entry.to}
            className="group relative block h-52 overflow-hidden rounded-lg md:h-64 cursor-pointer"
          >
            <img
              src={entry.image}
              alt={entry.title}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/60 to-primary-950/20"></div>
            <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-8">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i
                  className={
                    entry.type === "movie" ? "ri-film-line text-xl" : "ri-tv-2-line text-xl"
                  }
                ></i>
              </span>
              <h3 className="mt-3 font-heading text-xl font-black text-background-50 md:text-2xl">
                {entry.title}
              </h3>
              <p className="mt-2 max-w-md text-sm leading-relaxed text-background-100">
                {entry.desc}
              </p>
              <span className="mt-3 flex items-center gap-1 text-sm font-medium text-accent-400">
                立即进入
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}